module.exports = "/packs/images/homepage/activity/extreme_tablet~69c06290d68cbef872f46e5dc5227561.jpg";